import { JSX } from "react";
import { useTranslation } from "react-i18next";

import GroupCard from "@/components/cards/GroupCard.tsx";
import Carousel from "@/components/helpers/Carousel.tsx";
import Section from "@/components/helpers/Section/Section.tsx";

import { MainGenre } from "@/api/content/content.types.ts";
import { ROUTES } from "@/config/routes.ts";
import { useGetGenres } from "@/hooks/api/content.hooks.ts";
import { isMobile } from "@/utils/constatns";

const MainGenresSection = (): JSX.Element => {
  const { t } = useTranslation();
  const { data } = useGetGenres(12);

  return (
    <Section title={t("genres.genres")} link={ROUTES.MAIN.GENRES} className={"group/groups"}>
      <Carousel<MainGenre>
        swiperParams={{
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 16,
          followFinger: isMobile,
          breakpoints: {
            640: { slidesPerView: 3, slidesPerGroup: 3 },
            1024: { slidesPerView: 4, slidesPerGroup: 4 },
            1280: { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 12 },
            1440: { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 16 },
          },
        }}
        items={data.pages[0]}
        swiperName={"genres"}
      >
        {(genre) => (
          <GroupCard
            title={genre.name}
            link={ROUTES.MAIN.GENRE.replace(":id", genre.id.toString())}
            imageSrc={genre.picture.small}
          />
        )}
      </Carousel>
    </Section>
  );
};

export default MainGenresSection;
